<template>
  <div class="answer_sheet">
    <h2 class="title_com">答卷</h2>
    <section class="pd2430">
      <div class="top_box">
        <div class="title">
          <el-tag class="">{{ schedule.questionnaire_type_name }}</el-tag>
          <span class="fw600">{{ schedule.title }}</span>
        </div>
        <div class="time">
          <span class="fw600">时间：</span>
          <span v-if="schedule.start_date && schedule.end_date"
            >{{ schedule.start_date }} ~ {{ schedule.end_date }}</span
          >
          <span v-else> ———— </span>
        </div>
        <div class="last_row">
          <span class="fw600">隶属：</span>
          <span>{{ schedule.sub_name }}</span>
          <span class="fw600">匿名：</span>
          <!-- 问卷-是否匿名  1是 0否(问卷) -->
          <span>{{ schedule.questionnaire_is_anonymous ? "是" : "否" }}</span>
        </div>
      </div>
      <div class="explain p_cls" v-html="schedule.explain">
      </div>
      <!-- 问卷列表 -->
      <div class="subject_list">
        <div
          class="subject_box"
          v-for="(item, index) in subjectArr"
          :key="index"
        >
          <!-- 牛啊加多一层flex布局让flex为1的也不会占满其余空间 -->
          <div class="flex_X">
            <!-- 标题 -->
            <div class="title lh24">
              <span class="ed5565" v-if="item.is_required_answer">*</span>
              <span class="mt1">{{ index + 1 }}.</span>
              <span class="p_cls taj fw600 subject_title" v-html="item.title">
              </span>

              <span class="title_type">（{{ item.type | subjectTxt }}）</span>
            </div>
          </div>

          <!-- type:1选择题 2填空题 3排序题 4量表题 -->
          <!-- answer_type:答题方式 1单选 2多选 3量表 -->
          <!-- is_required_answer  '是否必答 0否 1是 -->
          <!-- 单选题 -->
          <div class="radio_t" v-if="item.type == 1 && item.answer_type == 1">
            <el-radio-group v-model="item.radio">
              <el-radio
                :label="radioItem.id + ''"
                v-for="(radioItem, radioIndex) in item.option"
                :key="radioItem.id"
                @change="changeRadio(index, radioIndex)"
                >{{ radioItem.content }}
                <!-- 需要回答的其他问题 -->
                <el-input
                  v-model="radioItem.iptVal"
                  v-if="radioItem.is_fill"
                ></el-input>
              </el-radio>
            </el-radio-group>
          </div>
          <!-- 多选题 -->
          <div class="more_t" v-if="item.type == 1 && item.answer_type == 2">
            <!-- <el-checkbox-group v-model="item.radio"> :label="itemMore.id + ''" -->
            <el-checkbox
              v-for="(itemMore, indexMore) in item.option"
              :key="indexMore"
              v-model="itemMore.checked"
              @change="checkboxEvent(itemMore)"
              >{{ itemMore.content }}
              <!-- 需要回答的其他问题 -->
              <el-input
                v-model="itemMore.iptVal"
                v-if="itemMore.is_fill"
              ></el-input>
            </el-checkbox>
            <!-- </el-checkbox-group> -->
          </div>
          <!-- 填空题 -->
          <!-- is_fill'是否填空 0否 1是', -->
          <div class="fill_empty" v-if="item.type == 2">
            <el-input
              type="textarea"
              v-model="fillItem.blank"
              :placeholder="'填空' + (fillIndex + 1)"
              v-for="(fillItem, fillIndex) in item.answer.answer_arr"
              :key="fillIndex"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="commit_btn" v-if="submit_type != 2 || is_allow_answer">
        <el-button type="primary" @click="submitForm">提交</el-button>
        <el-button @click="cancelForm">取消</el-button>
      </div>
    </section>
  </div>
</template>

<script>
import { QuestionDetailApi, commitQuestion } from "@/api/student";
export default {
  data() {
    return {
      questionId: "",
      submit_type: "", // 2已提交
      schedule: {},
      subjectArr: [], // 题目
      is_allow_answer: false
    };
  },
  filters: {
    // 过滤时间
    filterTime(val) {
      if (val.start_date && val.end_date) {
        let startArr = val.start_date.split(" ");
        let endArr = val.end_date.split(" ");
        let str = `${startArr[0]} ${startArr[1]}-${endArr[1]}`;
        return str;
      }
    },
    // 题目类型
    subjectTxt(value) {
      if (value == 1) {
        return "选择题";
      } else if (value == 2) {
        return "填空题";
      } else if (value == 3) {
        return "排序题";
      } else if (value == 4) {
        return "量表题";
      }
      return "";
    },
  },
  methods: {
    // 取消答卷
    cancelForm() {
      this.$router.go(-1);
    },
    // 提交答卷
    submitForm() {
      let answer = [];
      let unIndexArr = []; // 未填的第一题索引
      let isOk = true; // true:已经答完所有题目，反之没答完
      let isFill = true; // 选择题的回答必填
      let isFillArr = []; // 选择题的回答必填索引数组
      this.subjectArr.map((item, index) => {
        let temp = {
          questionnaire_id: item.questionnaire_id,
          questionnaire_subject_id: item.subject_id,
          questionnaire_subject_correlation_id: item.id,
        };
        // 选择题答案
        if (item.type == 1) {
          // 单选答案
          if (item.answer_type == 1) {
            // 记录未填题目的索引
            if (item.is_required_answer && item.radio == "") {
              unIndexArr.push(index);
            } else if (item.radio) {
              temp.questionnaire_subject_option_id = item.radio;
              temp.data = "";
              // 找出选中的选项
              let target = item.option.find((item2) => {
                return item2.id == item.radio;
              });
              if (target.is_fill) {
                if (target.iptVal) {
                  temp.data = target.iptVal;
                } else {
                  isFillArr.push(index);
                  //   console.log(isFillArr, "isFillArr");
                }
              }
              answer.push(temp);
              //   console.log(answer, "156");
            }
            //   temp.answer.push(setemp);
          }
          // 多选答案
          else {
            isOk = false;
            item.option.map((item3) => {
              if (item3.checked) {
                isOk = true;
                // 选择题的填空题
                if (item3.is_fill) {
                  if (item3.iptVal) {
                    item3.scale_option[0].data = item3.iptVal;
                  } else {
                    isFillArr.push(index);
                    //    console.log(isFillArr, "isFillArr");
                  }
                }
                let setemp = { ...temp, ...item3.scale_option[0] };
                answer.push(setemp);
                // console.log(setemp, "173");
              }
            });
            // 如果未填
            if (!isOk && item.is_required_answer) {
              unIndexArr.push(index);
            }
          }
        }
        // 填空题
        else if (item.type == 2) {
          // 记录未填题目的索引
          if (item.is_required_answer) {
            item.answer.answer_arr.map((item) => {
              // 只要有一项未填
              if (!item.blank) {
                unIndexArr.push(index);
              }
            });
          }
          // 过滤已经填空的
        //   let arr = item.fillArr.filter((item) => {
        //     return item.blank;
        //   });
         
          //   if (arr.length > 0) {
          let arr = item.answer.answer_arr.map((item) => {
            return item.blank;
          });
           console.log(arr, "arr");
          // 转成字符串
          temp.data = arr.join("#**#");
          temp.questionnaire_subject_option_id = item.object_id;
          answer.push(temp);
          //   }
        }
      });
        console.log(answer, "answer");
      // console.log(unIndexArr, "208");
      //   return;
      if (unIndexArr.length == 0) {
        if (isFillArr.length == 0) {
          if (answer.length > 0) {
            // return;
            commitQuestion({
              schedule_id: this.questionId, // this.questionId
              answer: JSON.stringify(answer),
            }).then((res) => {
              this.$message({
                showClose: true,
                message: "提交成功",
                type: "success",
              });
              setTimeout(() => {
                this.$router.go(-1);
              }, 1500);
            });
          } else {
            this.messageTips("提交问卷不能为空", "warning");
          }
        } else {
          this.$message({
            showClose: true,
            message: `第${isFillArr[0] + 1}道选择题的填空题未做！`,
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: `第${unIndexArr[0] + 1}题未做!`,
          type: "warning",
        });
      }
    },
    // 多选事件
    checkboxEvent(val) {
      val.scale_option = [];
      if (val.checked) {
        val.scale_option.push({
          questionnaire_subject_option_id: val.id,
          data: "",
        });
      } else {
        val.scale_option = [];
      }
    },
    // 单选事件
    changeRadio(index, radioIndex) {
      //   console.log(index,97);
      //   this.subjectArr[index].temp.letter = this.subjectArr[index].option[
      //     radioIndex
      //   ].letter;
      //   console.log(this.subjectArr[index],'99');
    },
    createFn() {},
  },
  created() {
    if (this.$route.query.is_allow_answer) {
      this.is_allow_answer = true;
    }
    this.questionId = this.$route.query.questionId;
    //问卷详细 this.questionId 497
    QuestionDetailApi({ id: this.questionId }).then((res) => {
      this.schedule = res.data.schedule;
      if (res.data.questionnaire.subject) {
        this.subjectArr = res.data.questionnaire.subject;
      }
      if (res.data.schedule_questionnaire) {
        let { submit_type } = res.data.schedule_questionnaire;
        this.submit_type = submit_type;
      }

      // 如果已经答题了
      if (this.submit_type == 2) {
        this.subjectArr.map((subjectItem) => {
          if (subjectItem.type == 1) {
            // 给每个选项添加input绑定的值,
            //   item.option.map((optionItem) => {
            //     if (optionItem.is_fill) {
            //       this.$set(optionItem, "iptVal", "");
            //     }
            //   });
            if (subjectItem.answer_type == 1) {
              // 回显单选题
              let target = subjectItem.option.find((item2) => {
                if (item2.is_fill && item2.current) {
                  this.$set(item2, "iptVal", item2.answer);
                }
                return item2.current == true;
              });
              if (target) {
                this.$set(subjectItem, "radio", target.id + "");
              }
            } else if (subjectItem.answer_type == 2) {
              // 回显多选题
              subjectItem.option.map((optionItem) => {
                if (optionItem.current) {
                  this.$set(optionItem, "checked", true);
                  if (optionItem.is_fill) {
                    this.$set(optionItem, "iptVal", optionItem.answer);
                  }
                }
              });
              //   this.$set(item, "radio", []);
            }
          } else if (subjectItem.type == 2) {
            // 回显填空题
            // this.$set(subjectItem, "fillArr", subjectItem.answer.answer_arr);
          }
        });
      } else {
        this.subjectArr.map((item) => {
          // type:1选择题 2填空题 3排序题 4量表题
          // answer_type:答题方式 1单选 2多选 3量表
          if (item.type == 1) {
            // 给每个选项添加input绑定的值,
            item.option.map((optionItem) => {
              if (optionItem.is_fill) {
                this.$set(optionItem, "iptVal", "");
              }
            });
            if (item.answer_type == 1) {
              this.$set(item, "radio", "");
            } else if (item.answer_type == 2) {
              item.option.map((optionItem) => {
                this.$set(optionItem, "checked", false);
              });
            }
          } else if (item.type == 2) {
            // this.$set(item, "fillArr", []);
            // for (var a = 0; a < item.multistage; a++) {
            //   item.fillArr.push({ blank: "" });
            // }
            // console.log(item, "361");
          }
        });
      }
      
    });
  },
  mounted() {},
};
</script>
 
<style lang = "less" scoped>
.answer_sheet {
  background-color: #fff;
  section {
    .top_box {
      padding-bottom: 24px;
      .title {
        .el-tag {
          margin-right: 20px;
          color: #999;
          background-color: #fff;
          border: 1px solid #999;
        }
      }
      .last_row {
        span {
          &:nth-child(2) {
            margin-right: 30px;
          }
        }
      }
      .time {
        padding: 12px 0;
      }
    }
    .explain {
      line-height: 24px;
      padding-bottom: 30px;
    }
    .subject_list {
      .subject_box {
        .title {
          display: flex;
          .title_type {
            color: #9bf;
            width: 80px;
          }
          .subject_title {
            flex: 1;
          }
        }
        /deep/ .radio_t {
          padding: 20px 0px;
          .el-radio-group {
            .el-radio {
              margin-top: 10px;
              display: flex;
              align-items: center;
              .el-radio__label {
                display: flex;
                align-items: center;
                .el-input__inner {
                  border: none;
                  border-bottom: 1px solid #409eff;
                  border-radius: 0;
                  height: 16px;
                  width: 120px;
                  position: absolute;
                  top: -9px;
                  left: 0;
                  color: #409eff;
                }
              }
            }
          }
        }
        /deep/ .more_t {
          padding: 20px 0px;
          .el-checkbox {
            display: flex;
            align-items: center;
            margin-top: 10px;
            .el-checkbox__label {
              display: flex;
              align-items: center;
              white-space: nowrap;
              position: relative;

              .el-input__inner {
                border: none;
                border-bottom: 1px solid #409eff;
                border-radius: 0;
                height: 16px;
                width: 120px;
                position: absolute;
                top: -9px;
                left: 0;
                color: #409eff;
              }
            }
          }
        }
        /deep/ .fill_empty {
          padding: 20px 0;
          .el-textarea__inner {
            width: 500px;
          }
          .el-textarea {
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .commit_btn {
      .el-button {
        width: 100px;
      }
    }
  }
}
</style>